import Joi from 'joi';
const newSpacingBlockSchema = Joi.object({
  type: Joi.string().valid('spacingNewBlock').required(),
  code: Joi.string().allow('', null).optional(),
  marginTop: Joi.string().allow('', null).optional(),
  marginBottom: Joi.string().allow('', null).optional(),
  background: Joi.string().allow('', null).optional()
}).unknown(true);
export default newSpacingBlockSchema;